import { useEffect, useRef, useState } from "react";
import ormOffersService from "../hooks/api/offers";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { cleanHtmlText, convertCurrency, stripHTML } from "../utils/formater";
import ORMfunctions from "../hooks/app/general";
// import Slider from "react-slick";

import { Swiper, SwiperSlide } from "swiper/react";
import {
  Pagination,
  EffectFade,
  Navigation,
  A11y,
  Thumbs,
  FreeMode,
} from "swiper/modules";

import SearchModal from "../components/modals/SearchmodalV2";

import { setOfferSelected, setSelectedVehicle } from "../store/orm/userSession";
import SlideNextButton from "../components/elements/swiper/next";
import SlidePrevButton from "../components/elements/swiper/prev";

interface SlickSlider {
  slickNext(): void;
  slickPause(): void;
  slickPlay(): void;
  slickPrev(): void;
  slickGoTo(slideNumber: number, dontAnimate?: boolean): void;
}

function Offers(props: any) {
  const offers = useSelector((state: RootState) => state.offers.offers);
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [enabledstations, setEnabledstations] = useState<string[] | undefined>(
    undefined,
  );

  const [claims, setClaims] = useState<any>([]);
  // const [controlledSwiper, setControlledSwiper] = useState(null);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  function generateClaim() {
    return props.claims[Math.floor(Math.random() * props.claims.length)];
  }

  useEffect(() => {
    ormOffersService.fetchOffers();
  }, []);

  useEffect(() => {
    for (let index = 0; index < offers.length; index++) {
      const element = generateClaim();
      setClaims((claims: any) => [...claims, element]);
    }
  }, [offers]);

  function setCar(offer: any) {
    setEnabledstations(offer.station_ids);

    dispatch(setOfferSelected(offer));
    dispatch(
      setSelectedVehicle({
        vehicleId: offer.vehicle_group_id,
        categories: offer.categories,
      }),
    );

    setShowModal(true);
  }

  function clearOffer() {
    dispatch(setOfferSelected(null));
    dispatch(setSelectedVehicle({ vehicleId: null, categories: null }));
    setShowModal(false);
  }

  return (
    <div className="orm-offers">
      <Swiper
        // effect={"fade"}
        spaceBetween={8}
        loop={true}
        modules={[EffectFade, A11y, Thumbs, Navigation]}
        // modules={[A11y, Thumbs, Navigation]}
        thumbs={{ swiper: thumbsSwiper }}
        a11y={true}
        autoHeight={false}
        observeParents={true}
        observer={true}
        observeSlideChildren={true}
        initialSlide={0}
        slidesPerView={1}
        // centeredSlides={true}
        navigation={false}
        // breakpoints={{
        //   1280: {
        //     initialSlide: 0,
        //     autoHeight: true,
        //     observer: true,
        //     observeParents: true,
        //     observeSlideChildren: true,
        //     slidesPerView: 1,
        //   },
        // }}
        onInit={() => {}}
      >
        {offers.map((offer: any, index: number) => (
          <SwiperSlide className="orm-offers-wrapper">
            <div className="orm-offers-imageWrapper">
              <SlideNextButton />
              <SlidePrevButton />
              <img
                className="orm-offers-image"
                src={offer.image_url}
                alt={`${offer.headline}-Bild`}
              />
            </div>

            <div className="orm-offers-content">
              <div className="orm-offers-teasline">
                {ORMfunctions.i18n("cargroup/offer") || "Angebot"}
              </div>
              <div
                className="orm-offers-headline"
                dangerouslySetInnerHTML={{
                  __html: stripHTML(offer.headline) || offer.headline,
                }}
              ></div>
              <div
                className="orm-offers-text"
                dangerouslySetInnerHTML={{
                  __html: cleanHtmlText(offer.description) || offer.description,
                }}
              ></div>

              <div className="orm-offers-pricing">
                <div className="orm-carprice">
                  <div className="orm-price__txt__surtitle">
                    {offer.price_text}
                  </div>
                  <div className="orm-price__txt">
                    {convertCurrency(offer.price)}
                  </div>
                </div>
                <div>
                  <div className="orm-offers-teaser">{claims[index]}</div>
                  <div
                    className="orm-offers-sidetext"
                    dangerouslySetInnerHTML={{
                      __html: offer.description2 || offer.description2,
                    }}
                  ></div>
                </div>
              </div>

              <div className="orm-offers-btnwrapper">
                <button
                  className="orm-button__cta orm-button__cta--offer wide"
                  onClick={() => setCar(offer)}
                >
                  {ORMfunctions.i18n("cargroup/select_offer") ||
                    "Angebot sichern"}
                  <i className="orm-button__cta--offer-icon far fa-stars"></i>
                </button>
              </div>
              <div
                className="orm-offers-legaltext"
                dangerouslySetInnerHTML={{
                  __html: offer.description3 || offer.description3,
                }}
              ></div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="swiper-thumb-pagination">
        <Swiper
          modules={[Pagination, Navigation, Thumbs, FreeMode]}
          watchSlidesProgress={true}
          slidesPerView={20}
          onSwiper={setThumbsSwiper}
          spaceBetween={8}
          className="mySwiper"
        >
          {offers.map((offer: any, index: number) => (
            <SwiperSlide className="swiper-thumb-bullet"></SwiperSlide>
          ))}
        </Swiper>
      </div>
      {showModal && (
        <SearchModal enabledstations={enabledstations} close={clearOffer} />
      )}
    </div>
  );
}

export default Offers;
